<script setup lang="ts">
useHead({ title: 'O nás' })

const aboutFeatures = [
  {
    title: '2016',
    text: 'V oboru od roku',
    icon: 'i-fubex-history',
  },
  {
    title: '20',
    text: 'Podporované kryptoměny',
    icon: 'i-fubex-crypto',
  },
  {
    title: '28',
    text: 'Celkem partnerů',
    icon: 'i-fubex-handshake',
  },
  {
    title: '5K',
    text: 'Spokojených klientů',
    icon: 'i-fubex-people',
  },

]
</script>

<template>
  <div :data-test="getCypressId('body-header')" fubex-container>
    <div flex flex-col gap-16px items-center mt-86px>
      <h1 display-sm md:display-lg text-neutral-900 font-700 text-center>
        V jednoduchosti je síla.
      </h1>
      <h2 heading6 text-center max-w-4xl>
        Vytváříme kryptoměnové produkty a služby vyladěné pro firmy i individuální uživatele. Našim cílem je snadné a praktické využití kryptoměn v běžném životě.
      </h2>
    </div>
    <div mt-72px flex flex-col gap-32px>
      <div flex flex-col md:flex-row gap-30px>
        <NuxtImg :src="`${'/img/aboutus.webp'}`" alt="" w-full max-h-450px md:w="50%" lg:w="50%" xl:w-full xl:max-h-339px fubex-rounded-lg object-cover />

        <div text-neutral-900 paragraph-md font-400 flex flex-col gap-24px>
          <p>Jsme přesvědčeni, že kryptoměny jsou nejen uchovatel hodnoty a peníze budoucnosti, ale přinesou i zásadní průlom ve fungování celé společnosti.</p>
          <p>Za 15 let od vzniku bitcoinu se povědomí společnosti o kryptoměnách výrazně zvýšilo. Aby se začaly hojně využívat v praxi každodenního života, potřebují firmy i běžní uživatelé jednoduché, snadné a bezpečné způsoby, jak na to. A přesně v tom spočívá naše úloha!</p>
          <p>Firmám přinášíme vyladěný fakturační systém pro vystavování faktur v kryptoměnách, řešení pro nákup kryptoměn na firmu a také možnost pořízení si vlastní směnárny přímo na své doméně a ve svých barvách.</p>
          <p>Běžným uživatelům nabízíme nejen směnu kryptoměn za výhodné kurzy, ale i řešení pro pravidelné nákupy.</p>
        </div>
      </div>
    </div>
  </div>
  <div w-full p-24px my-68px md:my-128px bg-neutral-900 class="light" fubex-shadow-lg>
    <div :data-test="getCypressId('widgets')" grid class="grid-cols-[repeat(auto-fit,minmax(200px,300px))]" place-items-center justify-center text-center gap-8px sm:gap-32px>
      <AboutFeature v-for="(item, index) in aboutFeatures" :key="index" :title="item.title" :text="item.text" :icon="item.icon" />
    </div>
  </div>

  <div class="fubex-container">
    <div :data-test="getCypressId('cards')" mb-172px>
      <h2 mt-56px mb-20px sm:mt-144px heading1 font-800 text-center>
        Mohlo by vás také zajímat
      </h2>
      <h3 text-center paragraph-md>
        Prozkoumejte naše další služby
      </h3>
      <WidgetPromotionCards />
    </div>
    <div :data-test="getCypressId('newsletter')" mb-72px>
      <WidgetNewsletter />
    </div>
  </div>
</template>
